import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { ISanityFee, ISanityFees } from '../../fragments/sanity-fees-parts';

interface FeesProps {
  fees: ISanityFees;
}

function Fees({ fees }: FeesProps): JSX.Element {
  if (!fees) <div></div>;
  return (
    <div className="relative bg-dark">
      <div className="absolute right-0">
        <StaticImage src="../../images/assets/steps-1.png" alt="" width={500} />
      </div>
      <div className="w-full px-4 py-12 mx-auto max-w-prose lg:max-w-screen-2xl sm:px-6 lg:px-8 lg:pt-24">
        <h2 className="relative flex flex-col items-center justify-center mb-10 text-black">
          {/* <StaticImage src="../../images/ribbon.png" alt="" height={50} /> */}
          <span className="font-serif text-3xl font-normal text-center text-highlight-ochre md:text-5xl">
            {fees.title}
          </span>
        </h2>
        <div className="flex justify-center">
          <div className="flex-wrap md:flex justify-evenly md:w-full">
            <TeamOfTwo fee={fees.teams.teamsOfTwo} />
            <TeamOfThreeFour fee={fees.teams.teamsOfThreeFour} />
            <TeamOfFiveSix fee={fees.teams.teamsOfFiveSix} />
          </div>
        </div>
        <div className="flex justify-center mt-4">
          <a
            href="/book-now"
            aria-label={`Read more about`}
            className="mt-10 space-x-1 text-sm uppercase"
          >
            <span className="px-16 py-4 text-base font-bold text-center bg-primary rounded-xl">
              Book Now
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export { Fees };

const teams = (teams: number) => (teams ? new Array(teams).fill('*') : []);

interface TeamProps {
  fee: ISanityFee;
}

function TeamOfTwo({ fee }: TeamProps): JSX.Element {
  return (
    <div className="relative flex flex-col items-center my-3 pt-14 w-80 h-96 bg-fees">
      <div className="absolute inset-0">
        <StaticImage src="../../images/assets/fees-bg.png" alt="" />
      </div>
      <div className="relative">
        <h3 className="font-serif text-2xl text-center">For teams of 2</h3>
        <div className="flex flex-col items-center my-4">
          <div className="flex">
            {teams(2).map((team, index) => (
              <div key={index} className="mx-1">
                <StaticImage src="../../images/team.png" alt="" width={50} />
              </div>
            ))}
          </div>
        </div>
        <div className="tracking-wide">
          {/* <div className="mb-6">
            <span className="text-3xl font-bold">${fee.exGST}</span> / per game
            ex GST
          </div> */}
          <div>
            <span className="text-3xl font-bold">${fee.inclGST}</span> / per
            game incl GST
          </div>
        </div>
      </div>
    </div>
  );
}

function TeamOfThreeFour({ fee }: TeamProps): JSX.Element {
  return (
    <div className="relative flex flex-col items-center my-3 pt-14 w-80 h-96">
      <div className="absolute inset-0">
        <StaticImage src="../../images/assets/fees-bg.png" alt="" />
      </div>
      <div className="relative">
        <h3 className="font-serif text-2xl text-center">For teams of 3 - 4</h3>
        <div className="flex flex-col items-center my-4">
          <div className="flex">
            {teams(4).map((team, index) => (
              <div key={index} className="mx-1">
                <StaticImage src="../../images/team.png" alt="" width={50} />
              </div>
            ))}
          </div>
        </div>
        <div className="tracking-wide">
          {/* <div className="mb-6">
            <span className="text-3xl font-bold">${fee.exGST}</span> / per game
            ex GST
          </div> */}
          <div>
            <span className="text-3xl font-bold">${fee.inclGST}</span> / per
            game incl GST
          </div>
        </div>
      </div>
    </div>
  );
}

function TeamOfFiveSix({ fee }: TeamProps): JSX.Element {
  return (
    <div className="relative flex flex-col items-center my-3 pt-14 w-80 h-96">
      <div className="absolute inset-0">
        <StaticImage src="../../images/assets/fees-bg.png" alt="" />
      </div>
      <div className="relative">
        <h3 className="font-serif text-2xl text-center">For teams of 5 - 6</h3>
        <div className="flex flex-col items-center my-4">
          <div className="flex">
            {teams(3).map((team, index) => (
              <div key={index} className="mx-1">
                <StaticImage src="../../images/team.png" alt="" width={50} />
              </div>
            ))}
          </div>
          <div className="flex">
            {teams(2).map((team, index) => (
              <div key={index} className="mx-1">
                <StaticImage src="../../images/team.png" alt="" width={50} />
              </div>
            ))}
          </div>
        </div>
        <div className="tracking-wide">
          {/* <div className="mb-6">
            <span className="text-3xl font-bold">${fee.exGST}</span> / per game
            ex GST
          </div> */}
          <div>
            <span className="text-3xl font-bold">${fee.inclGST}</span> / per
            game incl GST
          </div>
        </div>
      </div>
    </div>
  );
}
